import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import { API_URL, BASE_URL, Client_Id } from "../../../constants";
import Carousel from "react-bootstrap/Carousel";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import TextField from "@mui/material/TextField";
import { useGoogleLogin } from "@react-oauth/google";
import { Checkbox, colors, FormControlLabel, Tooltip } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setloginState } from "../../../redux/loginSlice";
import { Button } from "@mui/base";
import Swal from "sweetalert2";
import { displayNotification } from "../../../helpers";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { LoginSocialFacebook,LoginSocialApple, LoginSocialLinkedin } from "reactjs-social-login";
import { setUserType, setUserId } from "../../../redux/generalSlice";
import CardModal from '../register-form/ModalCustomCard';
import Loading from "../register-form/Loading";


import { jwtDecode } from 'jwt-decode'

// const REDIRECT_URI = "https://staging.commuterslink.com/auth/linkedin/callback";
const REDIRECT_URI = window.location.href;

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
const [modalOpen, setModalOpen] = useState(false);
  const [currentStep, setCurrentStep] = useState(1); // Track the sequence: 1 = number, 2 = commuter detail, 3 = commuter type
  const [number, setNumber] = useState(""); // State for the 11-digit number
  const [commuterDetail, setCommuterDetail] = useState("");
  const [commuterType, setCommuterType] = useState(""); // New state for rider/driver
  const [modalProps, setModalProps] = useState({
    title: "Enter Your Number",
    buttons: [], // Will be dynamically set based on step
    footer: "",
    width: "800px",
    height: "auto",
  });
  const [signUpBody, setSignUpBody] = useState({}) ;
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [termsService, setTermsService] = useState(true);
  const userToken = useSelector((s) => s.login.data.token);
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [navigate]);

  const checkUserStatus = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(`${API_URL}/api/v1/profile`, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      });

      const jsonresponse = await response.json();
      dispatch(setUserType(jsonresponse[0].type));
      dispatch(setUserId(jsonresponse[0].id));
      if (jsonresponse[0].approval_status === -1) {
        navigate("/rejection");
      } else {
        if (
          jsonresponse[0].type === "rider" &&
          jsonresponse[0].profile_status === 1 &&
          jsonresponse[0].approval_status === 0
        ) {
          navigate("/rider-registration");
        } else if (
          jsonresponse[0].type === "driver" &&
          jsonresponse[0].profile_status === 1 &&
          jsonresponse[0].approval_status === 0
        ) {
          navigate("/driver-registration");
        } else {
          navigate("/dashboard");
        }
      }
      // if (jsonresponse) {
      //   if (jsonresponse[0].userlist.vehicle_option === 0 && jsonresponse[0].profile_status === 2 && jsonresponse[0].approval_status === 1) {
      //     navigate("/dashboard");
      //   }
      //   else if (jsonresponse[0].userlist.vehicle_option === 0 && jsonresponse[0].profile_status === 2 && jsonresponse[0].approval_status === 0) {
      //     navigate("/verification");
      //   }
      //   else if (jsonresponse[0].userlist.vehicle_option === 0 && jsonresponse[0].profile_status === 2 && jsonresponse[0].approval_status === -1) {
      //     navigate("/rejection");
      //   }
      //   else if (jsonresponse[0].userlist.vehicle_option === 0 && jsonresponse[0].profile_status === 3 && jsonresponse[0].approval_status === 1) {
      //     navigate("/dashboard");
      //   }
      //   else if (jsonresponse[0].userlist.vehicle_option === 0 && jsonresponse[0].profile_status === 3 && jsonresponse[0].approval_status === 0) {
      //     navigate("/verification");
      //   }
      //   else if (jsonresponse[0].userlist.vehicle_option === 0 && jsonresponse[0].profile_status === 3 && jsonresponse[0].approval_status === -1) {
      //     navigate("/rejection");
      //   }
      //   else if (jsonresponse[0].userlist.vehicle_option === 1 && jsonresponse[0].profile_status === 5 && jsonresponse[0].approval_status === 1) {
      //     navigate("/dashboard");
      //   }
      //   else if (jsonresponse[0].userlist.vehicle_option === 1 && jsonresponse[0].profile_status === 5 && jsonresponse[0].approval_status === 0) {
      //     navigate("/verification");
      //   }
      //   else if (jsonresponse[0].userlist.vehicle_option === 1 && jsonresponse[0].profile_status === 5 && jsonresponse[0].approval_status === -1) {
      //     navigate("/rejection");
      //   }
      //   else if (jsonresponse[0].profile_status === 1) {
      //     navigate("/office_school");
      //   }
      // }
    } catch (error) {
      //console.error("An error occurred:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (userToken) {
      checkUserStatus();
    } else {
      navigate("/login");
    }
  }, [userToken]);

  const googlesignup = useGoogleLogin({
    // clientId: "380385507444-lr0o69cgjb9l3jf35sm2h87ffuv650m6.apps.googleusercontent.com",
    clientId: Client_Id,
    onSuccess: (codeResponse) => handleSuccess(codeResponse),
    onError: (codeResponse) => handleFailure(codeResponse),
  });
  const handleFailure = (response) => {
    //console.log("handleFailure", response);
  };

  // const handleFacebookSuccess = async (response) => {
  //   try {
  //     if (response && response.data.accessToken) {
  //       const body = {
  //         email: response.data.email,
  //         provider: response.provider,
  //       };

  //       //console.log("Facebook Body:", body);

  //       const res = await fetch(`${API_URL}/api/v1/auth`, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(body),
  //       });

  //       const jsonresponse = await res.json();

  //       if (jsonresponse.statusCode === 200) {
  //         dispatch(setloginState(jsonresponse.access_token));
  //       } else {
  //         displayNotification("error", `${jsonresponse.message}`);
  //       }
  //     } else {
  //       //console.error("Profile request failed with status:", response);
  //     }
  //   } catch (error) {
  //     //console.error("Error:", error.message);
  //   }
  // };

  const handleFacebookSuccess = async (response) => {
    try {
      if (response && response.data.accessToken) {
        // Fetch user profile from Facebook Graph API
        const profileResponse = await fetch(
          `https://graph.facebook.com/v20.0/me?fields=id,name,email&access_token=${response.data.accessToken}`
        );

        if (profileResponse.ok) {
          const userObject = await profileResponse.json();
          const body = {
            name: userObject.name || "Facebook User",
            email: userObject.email || `${userObject.id}@facebook.com`, // Fallback if email is not available
            provider: "facebook",
            provider_id: "FB" + generateRandomOtp(0, 1000000),
            facebooktoken: response.data.accessToken,
            password: "jWaeo@123" + generateRandomPassword(),
            token: response.data.accessToken,
            otp: generateRandomOtp(0, 1000000),
          };

          setSignUpBody(body);

          const res = await fetch(`${API_URL}/api/v1/auth`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
          });

          const jsonresponse = await res.json();

          if (jsonresponse.statusCode === 200) {
            dispatch(setloginState(jsonresponse.access_token));
          } else if (jsonresponse.message === "Email not found") {
            setModalOpen(true);
            setCurrentStep(1); // Open modal for signup flow
          } else {
            displayNotification("error", `${jsonresponse.message}`);
          }
        } else {
          console.error("Facebook profile request failed with status:", profileResponse.status);
        }
      }
    } catch (error) {
      console.error("Error:", error.message);
    }
  };
  const handleAppleSuccess = async (response) => {
    try {
       if (!response || !response.data || !response.data.authorization) {
        throw new Error("Invalid Apple Sign In response");
      }

      const { id_token, code } = response.data.authorization;
      const provider = response.provider; // 'apple'

      let decodedToken;
            try {
              decodedToken = jwtDecode(id_token);
            } catch (error) {
              throw new Error("Failed to decode id_token: " + error.message);
            }
            const email = decodedToken.email || null;
      if (response) {
        const body = {
          email: email,
          provider: provider,
        };

        //console.log("Facebook Body:", body);

        const res = await fetch(`${API_URL}/api/v1/auth`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        });

        const jsonresponse = await res.json();

        if (jsonresponse.statusCode === 200) {
          dispatch(setloginState(jsonresponse.access_token));
        } else {
          displayNotification("error", `${jsonresponse.message}`);
        }
      } else {
        //console.error("Profile request failed with status:", response);
      }
    } catch (error) {
      //console.error("Error:", error.message);
    }
  };

  const handleLogin = async () => {
    if (email === "" || password === "") {
      displayNotification("error", "Please Fill All Fields");
    } else {
      await postData();
    }
  };

  const postData = async () => {
    try {
      setIsLoading(true);
      if (termsService) {
        const body = {
          email: email,
          password: password,
        };
        const response = await fetch(`${API_URL}/api/v1/auth`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(body),
        });
        const jsonresponse = await response.json();

        if (jsonresponse.statusCode === 200) {
          dispatch(setloginState(jsonresponse.access_token));
        } else {
          setMessage(jsonresponse.message);
          displayNotification("error", `${jsonresponse.message}`);
        }
      }
      // else {
      //   setMessage("Please Check Terms of Services");
      //   displayNotification("error", "Please Check Terms of Services");
      // }
    } catch (error) {
      //console.log(error.message);
    } finally {
      setIsLoading(false);
    }
  };
  const validateEmail = (email) => {
    // Regular expression pattern for validating email addresses
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (emailPattern.test(email)) {
      setEmail(email);
      setIsValidEmail(true);
    } else {
      setIsValidEmail(false);
    }
  };
  const openPopup = () => {
    Swal.fire({
      html: `
        <div>
          <div class="container mt-5 pt-1 align-center fw-bold fs-1 mb-5">
            <span>
              Terms & Services</span>
          </div>
          <div>
            <div class="container">
              <div class="row">
                <div class="col-md-8 m-auto col-lg-12 col-sm-12 mb-5">
                  <div class="bg-light text-left text-danger">
                    <ol class="p-4 text-justify">
                      <li class="mb-2">
                      Your car is in good shape and is roadworthy</li>

                      <li class="mb-2">
                      You are committed to providing the car for commuting of partners on all days mentioned by your travel buddy
                      </li>
                 
                  
                    <li class="mb-2">If due to any unforeseen reason you cannot commute on a certain day, no fee will be paid for that day</li>
        
                   <li class="mb-2"> You will inform the travel buddy well in advance (at least 12 hours) about your inability to commute on a certain day. In case of any emergency, this can be waived off under exceptional circumstances</li> 
                            
                          <li class="mb-2">
                          You will be paid on weekly basis for the actual number of days that your car is used                      </li>
                      <li class="mb-2">
                      If a commuting partner misses the car and fails to commute due to late arrival/time off, you will still be paid for that day </li>
                         
                           <li class="mb-2">
                           You will wait at least 15 minutes after the agreed time for the commuting partner to join you                                          </li>
                           <li class="mb-2">You will update the scheduler in your dashboard on a daily (as and when required basis)</li>
                           <li class="mb-2">You will receive your share of the fee through CommutersLink, and there will be no direct transaction between you and your commuting partner</li>
                           <li class="mb-2">If you wish to discontinue your partnership with a member due to a reason or other, CommutersLink will inform the partner on your behalf. You are required to give at least 1 week notice</li>
                           <li class="mb-2">Any complaints or grievances will be addressed to CommutersLink for resolution.</li>
                           </ol>

                           </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      `,
      width: "50%", // Adjust the width as needed
      showCloseButton: true,
      showConfirmButton: false, // Remove confirm button if not needed
    });
  };
  const handleSuccess = async (response) => {
    try {
      if (response && response.access_token) {
        const profile = await fetch(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${response.access_token}`,
            },
            method: "get",
          }
        );

        if (profile.ok) {
          const userObject = await profile.json();
          const body = {
            name: userObject.name,
            email: userObject.email,
            provider: "google",
            provider_id: "DasD" + generateRandomOtp(0, 1000000),
            googletoken: response.access_token,
            password: "jWaeo@123" + generateRandomPassword(),
            token: response.access_token,
            otp: generateRandomOtp(0, 1000000),
            // phone: "",
          };

          setSignUpBody(body);

          const res = await fetch(`${API_URL}/api/v1/auth`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
          });

          const jsonresponse = await res.json();

          if (jsonresponse.statusCode === 200) {
            dispatch(setloginState(jsonresponse.access_token));
          }else if(jsonresponse.message === "Email not found") {
            setModalOpen(true);
            setCurrentStep(1)
              // alert("Email not found, Please Sign Up first");
          } else {
            displayNotification("error", `${jsonresponse.message}`);
          }
        } else {
          //console.error("Profile request failed with status:", profile.status);
        }
      }

    } catch (error) {
      //console.error("Error:", error.message);
    }
  };

  function generateRandomOtp(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
   function generateRandomPassword() {
    const length = 3;
    const charset =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_-+=<>?";
    let password = "";

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      password += charset.charAt(randomIndex);
    }

    return password;
  }

const handleCloseModal = () => {
    setModalOpen(false);
    setCurrentStep(1); // Reset to initial step if closed
    setNumber("");
    setCommuterDetail("");
    setCommuterType("");
  };

  const handleNumberChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // Remove non-digits
    setNumber(value);
  };

  const handleNextStep = () => {
    if (currentStep === 1 && number.length === 11) {
      setCurrentStep(2); // Move to commuter detail selection
      setModalProps({
        title: "Do you want to Commute to",
        buttons: [
          { text: "office", link: "" },
          { text: "university", link: "" },
        ],
        footer: "On long term basis",
        width: "800px",
        height: "auto",
      });
    }
  };

  const handleButtonClick = (text) => {
    if (currentStep === 2) {
      setCommuterDetail(text); // Set commuter detail immediately
      setCurrentStep(3); // Move to commuter type selection
      setModalProps({
        title: "Select Your Role",
        buttons: [
          { text: "Looking for a Car", link: "" },
          { text: "Offering Your Car", link: "" },
        ],
        footer: "Choose your commuting role",
        width: "800px",
        height: "auto",
      });
    } else if (currentStep === 3) {
      setCommuterType(text);
      setModalOpen(false); // Close modal after final selection
      signUp();
      // Navigate based on selections
      // if (commuterDetail === "office" && text === "Looking for a Car") {
      //   navigate("/rider-registration");
      // } else if (commuterDetail === "university" && text === "Looking for a Car") {
      //   navigate("/university-rider-registration");
      // } else if (commuterDetail === "office" && text === "Offering Your Car") {
      //   navigate("/driver-registration");
      // } else if (commuterDetail === "university" && text === "Offering Your Car") {
      //   navigate("/university-driver-registration");
      // }
    }
  };

  const signUp = async () => {
    try {
      const body = {
        ...signUpBody,
        number: number,
        commute_for: commuterDetail,
        confirm_password: signUpBody.password,
        type: commuterType === "Looking for a Car" ? "rider" : "driver",
      };
      console.log("Signup Body:", body);

      const res = await fetch(`${API_URL}/api/v1/signup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      const jsonresponse = await res.json();

      if (jsonresponse.statusCode === 200) {
         const res = await fetch(`${API_URL}/api/v1/auth`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(signUpBody),
          });

          const jsonresponse = await res.json();

          if (jsonresponse.statusCode === 200) {
            dispatch(setloginState(jsonresponse.access_token));
          }
        // dispatch(setloginState(jsonresponse.access_token));
      } else {
        displayNotification("error", `${jsonresponse.errors.number[0]}`);
      }
    } catch (error) {
      //console.error("Error:", error.message); 
    }
  };

  useEffect(() => {
    console.log("Current Step:", currentStep);
    console.log("11-digit Number:", number);  
    console.log("Commuter Detail:", commuterDetail);
    console.log("Commuter Type:", commuterType);
    console.log("email", signUpBody.email);
    console.log("provider", signUpBody.provider);

  }, [currentStep, number, commuterDetail, commuterType]);

  const home = () => {
    navigate("/");
  };
  return (
   
    <div>
      <div>
        <section
          id="sign-up"
          className="mt-5"
          style={{ backgroundColor: "#35677e" }}
        >
          <div className="container">
             {isLoading ? (<div className="d-flex align-items-center mx-auto my-auto justify-content-center">
              <Loading />
            </div>) : ""}
            {" "}
            <div className="row">
              <div
                className="col-md-6 d-flex"
                style={{
                  marginTop: "12vh",
                }}
              >
                <Carousel
                  style={{
                    backgroundColor: "#35677e",
                  }}
                  className="carousel-container"
                  prevIcon={null}
                  nextIcon={null}
                  indicators={null}
                >
                  <Carousel.Item interval={4000}>
                    <img
                      className="d-block img-fluid w-auto"
                      src={`${BASE_URL}/assets/images/signup.png`}
                      alt="First slide"
                    />
                    <h4 className="text-warning fw-bold text-center mt-2">
                      Share Actual Cost
                    </h4>
                  </Carousel.Item>

                  <Carousel.Item interval={4000}>
                    <img
                      className="d-block img-fluid w-auto"
                      src={`${BASE_URL}/assets/images/signup-3.png`}
                      alt="First slide"
                    />
                    <h4 className="text-warning fw-bold text-center mt-2">
                      Offer Your Car or Get a Seat in Other's Car
                    </h4>
                  </Carousel.Item>
                  <Carousel.Item interval={4000}>
                    <img
                      className="d-block img-fluid w-auto"
                      src={`${BASE_URL}/assets/images/signup-4.png`}
                      alt="First slide"
                    />
                    <h4 className="text-warning fw-bold text-center mt-2">
                      Share Ride for School University
                    </h4>
                  </Carousel.Item>
                  <Carousel.Item interval={4000}>
                    <img
                      className="d-block img-fluid w-auto"
                      src={`${BASE_URL}/assets/images/signup-6.png`}
                      alt="First slide"
                    />
                    <h4 className="text-warning fw-bold text-center mt-2">
                      Share Ride For Office
                    </h4>
                  </Carousel.Item>
                </Carousel>
                {/* </div> */}
              </div>

              <div className="col-md-5 mb-2 px-5">
                <h1
                  className="text-center text-custom  mb-2"
                  style={{
                    color: "#FFC738",
                    marginBottom: "5px",
                    marginTop: "10vh",
                  }}
                >
                  {" "}
                  Login
                </h1>{" "}
                <Form className="">
                  <Form.Group
                    className="mb-1 mt-5 text-center"
                    controlId="formBasicEmail"
                  >
<TextField
  fullWidth
  className="custom-textfield"
  variant="outlined"
  type="email"
  label="Email"
  onChange={(e) => validateEmail(e.target.value)}
  error={!isValidEmail}
  helperText={!isValidEmail && "Please enter a valid email"}
  size="small"
  sx={{
    width: "100%",
  }}
/>
                  </Form.Group>
                  <Form.Group
                    className="mt-3 text-center"
                    controlId="formBasicEmail"
                  >
  <TextField
  fullWidth
  variant="outlined"
  className="custom-textfield"
  type={showPassword ? "text" : "password"}
  label="Password"
  onChange={(e) => setPassword(e.target.value)}
  size="small"
  sx={{
    width: "100%",
  }}
  InputProps={{
    endAdornment: (
      <InputAdornment position="end">
        <IconButton onClick={togglePasswordVisibility} edge="end" className="password-toggle">
          {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
        </IconButton>
      </InputAdornment>
    ),
  }}
/>
                  </Form.Group>

                  <div className="py-1 text-right">
                    <Link to={"/forget"} style={{ textDecoration: "none" }}>
                      <span
                        style={{
                          color: "rgb(255, 199, 56)",
                          textDecoration: "none",
                        }}
                      >
                        Forgot Password
                      </span>
                    </Link>
                  </div>
                  {/* <div className="col-md-12 text-center mt-3">
                    <FormControlLabel
                      control={
                        <Checkbox
                          value="termsService"
                          style={{ borderColor: "#FFC738" }}
                          onChange={(e) => setTermsService(e.target.checked)}
                          size="small"
                        />
                      }
                      label={
                        <div id="span-text" className="mr-5 text-bold">
                          I agree with all statements in
                          <Link
                            // to={'/terms_services'}
                            onClick={openPopup}
                            style={{ textDecoration: "none" }}>
                            <span
                              style={{
                                color: "#FFC738",
                                textDecoration: "none",
                              }}
                            >
                              &nbsp;
                              Terms of Service
                            </span>
                          </Link>
                        </div>
                      }
                    />
                  </div> */}
                  <div></div>
                  {message && (
                    <span className="text-danger text-center">
                      <strong>{message}</strong>
                    </span>
                  )}

                  <div className="text-center">
                    <Button
                      className="btn-custom1 mx-2 text-center border-0 px-4 py-2 rounded rounded-2 text-black fw-bold"
                      onClick={handleLogin}
                      disabled={isLoading}
                      // style={{backgroundColor: "#FFC738"}}
                    >
                      {isLoading ? (
                        <span>
                          <i className="fa fa-spinner fa-spin" /> Loging In...
                        </span>
                      ) : (
                        "Login"
                      )}
                    </Button>
                  </div>
                  <div className="container">
                    <div className="row d-flex justify-content-center">
                      <div className="column mt-2">
                        <p className="  text-center" id="text2" style={{ color: "#f8b305" }} >
                          Or continue with
                        </p>
                      </div>
                      <div className="column">
                        <ul
                          className="list-unstyled  d-flex "
                          style={{
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {modalOpen && (
                            <CardModal
                              open={modalOpen}
                              onClose={handleCloseModal}
                              title={modalProps.title}
                              buttons={modalProps.buttons}
                              footer={modalProps.footer}
                              width={modalProps.width}
                              height={modalProps.height}
                              onButtonClick={handleButtonClick}
                              currentStep={currentStep}
                              number={number}
                              onNumberChange={handleNumberChange}
                              onNextStep={handleNextStep}
                            />
                          )}
                          <li className="mr-3">
                            <Tooltip title="Login With Google">
                              <a onClick={googlesignup}>
                                <img
                                  src={`${BASE_URL}/assets/images/google.png`}
                                  alt=""
                                  style={{
                                    height: "25px",
                                    width: "25px",
                                    cursor: "pointer",
                                  }}
                                />
                              </a>
                            </Tooltip>
                          </li>
                          <li className="mr-3">
                            <LoginSocialFacebook
                              // appId="264760359845922"
                              appId="832351251716749"
                              onResolve={(response) => {
                                handleFacebookSuccess(response);
                              }}
                              onReject={(error) => {
                                //console.log("Facebook Error Message:", error);
                              }}
                            >
                              <Tooltip title="Signup With Facebook">
                                <img
                                  src={`${BASE_URL}/assets/images/facebook.png`}
                                  alt=""
                                  style={{
                                    height: "27px",
                                    width: "27px",
                                    cursor: "pointer",
                                  }}
                                />
                              </Tooltip>
                            </LoginSocialFacebook>
                          </li>
                          <li className="mr-1">
                            <LoginSocialApple
                              client_id="com.commuterslink.applelogin"
                              redirect_uri="https://commuterslink.com/"
                              onResolve={(response) => {
                                handleAppleSuccess(response);
                                console.log("Apple login success:", response);
                              }}
                              onReject={(error) => {
                                console.error("Apple login error:", error);
                              }}
                            >
                              <Tooltip title="Login With Apple">
                                <img
                                  src={`${BASE_URL}/assets/images/apple.png`}
                                  alt="Apple login"
                                  style={{
                                    height: "45px",
                                    width: "43px",
                                    cursor: "pointer",
                                  }}
                                />
                              </Tooltip>
                            </LoginSocialApple>
                          </li>
                          {/* <li>
                            <LoginSocialLinkedin
                              client_id="86th1m5dtehgx3"
                              client_secret="YY1HZ3JYb4jM5btI"
                              redirect_uri={REDIRECT_URI}
                              onResolve={(response) => {
                                //console.log("LinkedIn Response:", response);
                              }}
                              onReject={(error) => {
                                //console.log("LinkedIn Error Message:", error);
                              }}
                            >
                              <Tooltip title="Login With Linkedin">
                                <img
                                  src={`${BASE_URL}/assets/images/linkedin.png`}
                                  alt=""
                                  style={{ height: "35px", width: "35px", cursor: "pointer" }}
                                />
                              </Tooltip>
                            </LoginSocialLinkedin>
                          </li> */}
                        </ul>
                      </div>
                    </div>
                    <hr id="hrline2" style={{color:"#fff"}} />
                    <div id="span-text" className="text-center mb-5" style={{color: "#f8f7f4"}}>
                      Don't have an account on CommutersLink? &nbsp;
                      <Link to={"/"} style={{ textDecoration: "#FFC738" }}>
                        <span
                          className="reg-text"
                          style={{ color: "#FFC738" }}
                        >
                          Signup
                        </span>
                      </Link>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Login;
